import React, { useState } from 'react';
import Button from '../../../components/presentational/Button';
import Icon from '../../../components/presentational/Icon';
import { formatHolidayCostAsInteger } from '../../../lib/currencyUtilities';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Holiday } from '../../../models/holiday';
import theme from '../../../lib/theme';

import holidayBlockStyles from './HolidayBlock_styles';
import { HolidayBlockProps } from './HolidayBlock';
import { getHolidaySlug } from '../../../lib/holidayUtils';

const {
  scale,
  layers,
  layouts,
  corners,
  colors,
  media,
  font: { families, heights, spacings, ...font },
} = theme;

export interface HolidayCardProps extends HolidayBlockProps {
  holiday: Holiday;
}

const HolidayCard = ({
  block: { columns_per_row },
  holiday,
  classes,
  styles,
}: HolidayCardProps & StylesProps<typeof holidayBlockStyles>) => {
  // console.log('HolidayBlock', {featured_holiday});

  const renderHolidayMeta = (holiday: Holiday) => {
    return (
      <div
        className={cx(
          `holiday-meta d-flex flex-column flex-grow-1 justify-content-start pb-2 w-100`,
          styles.holidayContent
        )}
      >
        <div className={cx(`holiday-days-nights`, styles.holidayDaysNights)}>
          <Icon icon="history" className={`mr-3 ${styles.holidayIcon}`} />
          {holiday.days > 0 && `${holiday.days} days, `}
          {holiday.nights} nights
        </div>
        <span
          className={`holiday-web-selling-points check-bullet-list ${styles.holidayInclusions}`}
          dangerouslySetInnerHTML={{ __html: holiday.web_selling_point }}
        />
      </div>
    );
  };

  return (
    <a
      key={holiday.slug}
      className={cx(
        `card holiday-card holiday-card-clickable`,
        classes,
        styles.holidayCard
      )}
      style={{
        flexBasis: `calc(${100 / columns_per_row}% - 1rem)`,
        maxWidth: `calc(${100 / columns_per_row}% - 1rem)`,
      }}
      href={getHolidaySlug(holiday)}
    >
      <div className={styles.holidayCardImage}>
        <img
          loading={'lazy'}
          src={`${holiday.feature_images[0].path}?w=500`}
          alt={holiday.feature_images[0].description}
        />
        {holiday.promo_text && (
          <div className={styles.holidayCardPromoRibbon}>
            {holiday.promo_text}
          </div>
        )}
      </div>
      <div className={`${styles.holidayContentContainer}`}>
        <div
          className={cx(
            `d-flex align-items-center flex-shrink-0 w-100 justify-content-between`,
            styles.holidayContentHeader
          )}
        >
          <h5 className={`p-0 ${styles.holidayTitle}`}>{holiday.title}</h5>
          <div className={`flex-grow-0 d-flex flex-column text-right`}>
            <small
              className="display-block"
              style={{
                color: colors.black,
              }}
            >
              from
            </small>
            <h5 className={styles.holidayPrice}>
              {formatHolidayCostAsInteger(
                holiday.price_cents || holiday.solo_price_cents
              )}
              <small
                style={{
                  fontWeight: 700,
                  fontSize: font.xs,
                  marginBottom: '1px',
                }}
              >
                PP
              </small>
            </h5>
          </div>
        </div>
        {renderHolidayMeta(holiday)}
        <div
          className={cx(
            `d-flex justify-content-end w-100`,
            styles.holidayContentFooter
          )}
        >
          <Button
            className={styles.holidayMoreDetailsButton}
            inverted={true}
            href={getHolidaySlug(holiday)}
          >
            Learn more
          </Button>
        </div>
      </div>
    </a>
  );
};

export default styled(holidayBlockStyles)(HolidayCard);
